export const filtroProcedimentoOptions = [
  {
    label: "Profissional",
    value: "PROFISSIONAL",
  },
  {
    label:"Convênio",
    value: "CONVENIO",
  }
]

export const TipoCancelamentoOptions = [
  {
    label:'Não utiliza',
    value: null
  },
  {
    label:'Fixo',
    value: 'FIXO'
  },
  {
    label:'Campo aberto',
    value: 'CAMPO_ABERTO'
  },
]

export const situacoesAgendamento = [
  {
    value: "AGENDADO", 
    label: "Agendado"
  },
  {
    value: "CONFIRMADO", label: "Confirmado"
  },
  { 
    value: "AGUARDANDO",
    label: "Aguardando"},
  { 
    value: "ATENDENDO",
    label: "Atendendo"
  },
  { 
    value: "ATENDIDO",
    label: "Atendido"
  },
  { 
    value: "CANCELADO",
    label: "Cancelado"
  },
  { 
    value: "EXCLUIDO",
    label: "Excluido"
  },
  { 
    value: "BLOQUEADO",
    label: "Bloqueado"
  },
  { 
    value: "FALTOU",
    label: "Faltou"
  },
]
